import SubscriptionSelection from './SubscriptionSelection';

export default SubscriptionSelection;
